import React, { useState } from "react";
import {
  Button,
  Header,
  Grid,
  Segment,
  Image,
  Icon,
  Accordion,
} from "semantic-ui-react";
import * as formatUtils from "../../../app/util/formatUtils";
import PropTypes from "prop-types";
import {
  getNombreCampania,
  getSubTituloCampania,
} from "../../../app/util/textCodeUtils";
import { sendNotificacionSectorista } from "../../../app/store/actions/campaniaActions";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import history from "../../..";
import {
  CODIGO_ORIGEN_CAMPANIA_MICRO,
  CODIGO_ORIGEN_CAMPANIA_MICASH,
  MSG_VER_TERMINOS_CONDICIONES,
} from "../../../app/infrastructure/appConstants";
import TerminosLegalCampaniaMiCashText from "../../../app/common/text/TerminosLegalCampaniaMiCashText";
import TerminosLegalCampaniaMicroText from "../../../app/common/text/TerminosLegalCampaniaMicroText";

const actions = {
  sendNotificacionSectorista,
};

const CampaniaCard = ({ campania, sendNotificacionSectorista }) => {
  //states
  const [activeIndex, setActiveIndex] = useState(1);
  const handleClickTerminosCondiciones = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };
  //actions
  const handleSendNotificacionSectorista = async () => {
    const notificacion = {
      codigoUsuario: campania.codigoUsuario,
      origenCampania: campania.indicadorOrigen,
      nombreProducto: campania.nombreProducto,
      importeAprobado: campania.importeAprobado,
      plazoAprobado: campania.plazoAprobado,
      tasaAprobado: campania.tasaAprobado,
      cuotaAprobado: campania.cuotaAprobado,
    };
    try {
      const response = await sendNotificacionSectorista(notificacion);
      toast.success(response.message);
      history.push("/inicio");
    } catch (error) {
      toast.error(error.data.message);
    }
  };

  return (
    <Segment>
      <Grid stackable columns={2} style={{ marginTop: "0.1em" }}>
        <Grid.Row>
          <Grid.Column width={7}>
            <Header
              as="h4"
              color="blue"
              textAlign="left"
              content={`${getNombreCampania(campania.indicadorOrigen)}`}
            />
            <Header
              as="h5"
              color="violet"
              textAlign="left"
              style={{ margin: "calc(1rem -  0.14285em ) 0em 1rem" }}
              content={`${getSubTituloCampania(campania.indicadorOrigen)}`}
            />
            {campania.indicadorOrigen === CODIGO_ORIGEN_CAMPANIA_MICRO ? (
              <Image src="/assets/images/campania-micro.png" size="large" />
            ) : (
              campania.indicadorOrigen === CODIGO_ORIGEN_CAMPANIA_MICASH && (
                <Image src="/assets/images/campania-mi-cash.png" size="large" />
              )
            )}
          </Grid.Column>
          <Grid.Column width={9}>
            <p style={{ fontWeight: "bold" }}>Condiciones:</p>
            <p>
              <Icon name="calendar alternate outline" color="yellow" />
              {` Plazo: ${formatUtils.fomartPlazo(campania.plazoAprobado)}`}
            </p>
            <p>
              <Icon name="money bill alternate outline" color="yellow" />
              {` Monto Máximo: ${
                campania.nombreMoneda
              } ${formatUtils.formatMoney(campania.importeAprobado, 0)}`}
            </p>
            <p>
              <Icon name="percent" color="yellow" />
              {` Tasa: ${formatUtils.fomartTasa(campania.tasaAprobado)}`}
            </p>{" "}
            <p>
              <Icon name="hourglass half" color="yellow" />
              {` Vigencia hasta el: ${formatUtils.dateFormat(
                campania.fechaVencimiento
              )}`}
            </p>
            <p style={{ fontWeight: "bold" }}>Contacto:</p>
            <p>
              <Icon name="user outline" color="yellow" />
              {` ${campania.contacto}`}
            </p>
            <br />
            <Grid>
              <Grid.Column mobile={12} largeScreen={8} tablet={8} computer={8}>
                <Button
                  color="yellow"
                  size="large"
                  content="Solicitar"
                  fluid
                  onClick={handleSendNotificacionSectorista}
                />
              </Grid.Column>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ marginTop: "-1rem" }}>
          <Grid.Column width={16}>
            <Accordion>
              <Accordion.Title
                active={activeIndex === 0}
                index={0}
                onClick={handleClickTerminosCondiciones}
                style={{ color: "#c9c9c9" }}
              >
                <Icon name="dropdown" />
                {MSG_VER_TERMINOS_CONDICIONES}
              </Accordion.Title>
              <Accordion.Content
                active={activeIndex === 0}
                style={{ color: "#c9c9c9" }}
              >
                {campania.indicadorOrigen === CODIGO_ORIGEN_CAMPANIA_MICRO ? (
                  <TerminosLegalCampaniaMicroText />
                ) : (
                  campania.indicadorOrigen ===
                    CODIGO_ORIGEN_CAMPANIA_MICASH && (
                    <TerminosLegalCampaniaMiCashText />
                  )
                )}
              </Accordion.Content>
            </Accordion>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

CampaniaCard.propTypes = {
  campania: PropTypes.object.isRequired,
};

export default connect(null, actions)(CampaniaCard);
